import React from "react";

/** Marks the first occurrence of the search term. Built from text nodes, so nothing in a payload can inject markup. */
export const Highlight = ({ text, query }: { text: string | number | null | undefined; query?: string }) => {
  const value = text === null || text === undefined ? "" : String(text);
  const index = query ? value.toLowerCase().indexOf(query.toLowerCase()) : -1;

  if (!query || index === -1) return <>{value}</>;

  return (
    <>
      {value.slice(0, index)}
      <mark>{value.slice(index, index + query.length)}</mark>
      {value.slice(index + query.length)}
    </>
  );
};
